import { viewStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    css: css`
        ${styles.container?.css}
        margin: 0 0 64px;
    `,
    offsetCss: css`
        ${styles.container?.offsetCss}
        margin: 0 0 64px;
        width: 100%;
        gap: 16px;
        flex-wrap: nowrap !important;
    `,
};

styles.topGridItem = {
    ...styles.topGridItem,
    css: css`
        ${styles.topGridItem?.css}
        position: relative;
        width: 100%;
        margin: 22px 0 20px;

        & > div {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 16px;
            flex-wrap: wrap;

            .productDetailsPrimaryImage {
                flex: 1 1 100%;
            }
        }

        ${mediaQueriesBP.maxMD} {
            padding: 15px;
        }

        ${mediaQueriesBP.minMD} {
            padding: 10px 15px;
            display: inline-flex;
            align-items: center;
        }

        .productDetailsPrimaryImage {
            ${mediaQueriesBP.minMD} {
                width: calc(100% - 95px);
            }
        }

        .productDetailsImageCarousel {
            ${mediaQueriesBP.maxMD} {
                margin-top: 15px;
            }

            ${mediaQueriesBP.minMD} {
                position: absolute;
                right: 15px;
                width: 78px;
                height: 690px;
                bottom: 10px;
            }
        }
    `,
};

styles.middleGridItemHidden = {
    ...styles.middleGridItemHidden,
    css: css`
        ${styles.middleGridItemHidden?.css};
        padding: 24px;
        border: solid 1px ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;

        ${mediaQueriesBP.maxLG} {
            padding: 10px;
        }

        & > div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        ${GridOffset} {
            width: 100%;
            margin: 0;
        }
    `,
};

styles.rightColumnGridItemHidden = {
    ...styles.rightColumnGridItemHidden,
    css: css`
        ${styles.rightColumnGridItemHidden?.css};
        padding: 24px;
        border: solid 1px ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;

        ${mediaQueriesBP.maxLG} {
            padding: 10px;
        }

        ${mediaQueriesBP.minMD} {
            margin-top: 40px;
        }

        & > div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    `,
};
